import * as React from "react";
import { styled } from "@mui/material/styles";
import MuiAppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import AccountCircle from "@mui/icons-material/AccountCircle";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MoreIcon from "@mui/icons-material/MoreVert";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { socket } from "./socket";

import "react-toastify/dist/ReactToastify.css";

/* ================= AppBar Styling ================= */
const AppBar = styled(MuiAppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  background: "linear-gradient(90deg, #024234ff, #0F172A)",
  borderBottom: "1px solid rgba(255,255,255,0.05)",
  boxShadow: "none",
}));

export default function NavBar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const [unreadMessages, setUnreadMessages] = React.useState(0);
  const [unreadNotifications] = React.useState(0);
  const [userName, setUserName] = React.useState("User");

  const location = useLocation();

  /* ================= Socket ================= */
  React.useEffect(() => {
    socket.off("newMessage");

    socket.on("newMessage", (msg) => {
      if (!msg) return;

      const clinicNumbers = [
        "whatsapp:+971542340466",
        "whatsapp:+971505000000",
      ];

      const isOutbound =
        msg.fromMe ||
        clinicNumbers.some((num) => msg.from?.includes(num));

      if (isOutbound) return;

      setUnreadMessages((prev) => prev + 1);

      const audio = new Audio("/notification.mp3");
      audio.play().catch(() => { });

      const content =
        msg.body?.trim() ||
        (msg.mediaType?.startsWith("audio") && "🎙️ Voice message") ||
        (msg.mediaType?.startsWith("image") && "🖼️ Image") ||
        "📎 New file";

      toast.info(`💬 ${msg.profileName || msg.from}: ${content}`, {
        position: "bottom-right",
        autoClose: 6000,
        theme: "colored",
      });
    });

    return () => socket.off("newMessage");
  }, []);

  /* ================= Reset unread ================= */
  React.useEffect(() => {
    if (location.pathname.includes("/whatsapp1")) {
      setUnreadMessages(0);
    }
  }, [location.pathname]);

  /* ================= User ================= */
  React.useEffect(() => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.name) setUserName(user.name);
    } catch {
      setUserName("User");
    }
  }, []);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  /* ================= Menus ================= */
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      open={isMenuOpen}
      onClose={() => setAnchorEl(null)}
      PaperProps={{
        sx: {
          backgroundColor: "#020617",
          color: "#E5E7EB",
          border: "1px solid rgba(255,255,255,0.05)",
        },
      }}
    >
      <MenuItem disabled>
        <Typography fontWeight={600}>{userName}</Typography>
      </MenuItem>

      <MenuItem
        onClick={() => (window.location.href = "/my-account")}
        sx={{
          "&:hover": {
            backgroundColor: "rgba(37,99,235,0.15)",
          },
        }}
      >
        My Account
      </MenuItem>
    </Menu>
  );

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      open={isMobileMenuOpen}
      onClose={() => setMobileMoreAnchorEl(null)}
      PaperProps={{
        sx: {
          backgroundColor: "#020617",
          color: "#E5E7EB",
        },
      }}
    >
      {/* <MenuItem>
        <Badge badgeContent={unreadMessages} color="error">
          <WhatsAppIcon />
        </Badge>
        <Typography sx={{ ml: 2 }}>Messages</Typography>
      </MenuItem> */}

      <MenuItem>
        <NotificationsIcon />
        <Typography sx={{ ml: 2 }}>Notifications</Typography>
      </MenuItem>

      <MenuItem onClick={() => (window.location.href = "/my-account")}>
        <AccountCircle />
        <Typography sx={{ ml: 2 }}>{userName}</Typography>
      </MenuItem>
    </Menu>
  );

  /* ================= Render ================= */
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="fixed">
        <Toolbar>
          <IconButton color="inherit" sx={{ mr: 2 }}>
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
            Ebn Haian/HR
          </Typography>

          <Box sx={{ display: { xs: "none", md: "flex" } }}>
            {/* <IconButton color="inherit">
              <Badge badgeContent={unreadMessages} color="error">
                <Link to="/whatsapp" style={{ color: "#E5E7EB" }}>
                  <WhatsAppIcon />
                </Link>
              </Badge>
            </IconButton> */}

            <IconButton color="inherit">
              <NotificationsIcon />
            </IconButton>

            <IconButton
              color="inherit"
              onClick={(e) => setAnchorEl(e.currentTarget)}
            >
              <AccountCircle />
              <Typography sx={{ ml: 1 }}>{userName}</Typography>
            </IconButton>
          </Box>

          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              color="inherit"
              onClick={(e) => setMobileMoreAnchorEl(e.currentTarget)}
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {renderMenu}
      {renderMobileMenu}
    </Box>
  );
}
